import styled from 'styled-components';
import { BodyRegularS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 432px;
  align-items: center;

  ${({ theme }: IThemeProvider) => `
      margin-top: ${theme.layout.spacing.centy};
  `}

  [data-testid='input-label'] {
    ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.primary[100]};
  `}
  }
`;

export const Link = styled(BodyRegularS)`
  align-self: flex-end;
  text-decoration-line: underline;
  cursor: pointer;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.deka};
    color: ${theme.colors.primary[100]};
  `}
`;

export const ApiErrorCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    margin-bottom: ${theme.layout.spacing.deka};
  `}
`;

export const InputCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
`;
